export default "__VITE_ASSET__Ttc3oy7q__"